// Copyright (c) Said Borna. All rights reserved.
import { type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginForm } from '@/components/auth/LoginForm';
import { useAuth } from '@/contexts/AuthContext';
import { isStaffRole } from '@/types';

/**
 * Login page — redirects authenticated users to their appropriate dashboard.
 * Clean, centered, authoritative design.
 */
export default function LoginPage(): ReactElement {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center bg-[#F9FAFB]">
                <div className="flex flex-col items-center gap-3">
                    <div className="h-8 w-8 animate-spin rounded-full border-2 border-foreground border-t-transparent" />
                    <p className="text-sm text-muted-foreground">Loading...</p>
                </div>
            </div>
        );
    }

    if (user) {
        const destination = isStaffRole(user.role) ? '/admin/content-manager' : '/dashboard';
        return <Navigate to={destination} replace />;
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#F9FAFB]">
            <LoginForm />
        </div>
    );
}
